import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";
 
export class CTRL_528 implements Validator { 
 
    public static id = 'CTRL_528'; 
    private message = 'error.ctr_528'; //message d’erreur en dur, à terme dans un JSON FR ou EN 
 
 
 
 
    validate(form: any, map) { 
 
 
        // vérifier si la règle est applicable sur mon formulaire 
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_528.id); 
 
 
        if (rgs.length > 0) { 
            for (var rg of rgs) { 
                const ctrl = form.controls[rg]; 
			//ajout du STEP_ID sur le champ 
                const dateAcompterDuWithStepId = map.get(ctrl.value.rgCtrls.dateACompterDu);
                const dateJusquAuWithStepId = map.get(ctrl.value.rgCtrls.dateJusquau);
                const dateAcompterDu = form.controls[dateAcompterDuWithStepId];
                const dateJusquAu = form.controls[dateJusquAuWithStepId];
                if ((this.isPattern(dateAcompterDu.value) && !this.isPattern(dateJusquAu.value)) || (!this.isPattern(dateAcompterDu.value) && this.isPattern(dateJusquAu.value))) { 
                    // placer le message d'erreur 
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message }; 
                } else { 
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false }; 
                } 
            } 
        } 
    } 

    isPattern(value): boolean{
        return (value !== undefined && value !== null && value !== '' && value !== "yyyy-MM-dd");
    }
} 
 
